import React from "react";
import {
  Container,
  Typography,
  Link,
  Box,
  CssBaseline,
  Paper,
} from "@mui/material";

const PrivacyPolicy: React.FC = () => {
  return (
    <Container component="main" maxWidth="md">
      <CssBaseline />
      <Paper elevation={3} sx={{ padding: 4, marginTop: 4 }}>
        <Typography variant="h4" gutterBottom>
          Términos y Condiciones y Política de Privacidad
        </Typography>

        <Typography variant="subtitle1" color="textSecondary">
          Última actualización: 2 de marzo del 2025
        </Typography>

        <Box mt={2}>
          <Typography variant="h6">1. Introducción</Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Gracias por utilizar nuestros servicios. Valoramos tu privacidad y
            nos comprometemos a proteger tu información personal. Esta política
            explica cómo utilizamos la integración con WhatsApp Cloud API y cómo
            puedes solicitar la eliminación de datos si así lo deseas.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Al utilizar nuestros servicios, aceptas los términos y condiciones
            descritos en este documento. Si no estás de acuerdo con ellos, te
            recomendamos no utilizar nuestros servicios.
          </Typography>
        </Box>

        <Box mt={2}>
          <Typography variant="h6">2. Información y Privacidad</Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Nuestro servicio utiliza WhatsApp Cloud API para enviar
            notificaciones y recordatorios.{" "}
            <strong>No almacenamos ni recopilamos información personal</strong>{" "}
            de los usuarios. Toda la información procesada, incluidos los
            mensajes y números de teléfono, es manejada directamente por
            WhatsApp y está sujeta a la{" "}
            <Link
              href="https://www.whatsapp.com/legal/privacy-policy"
              target="_blank"
              rel="noopener"
            >
              Política de Privacidad de Meta
            </Link>
            .
          </Typography>
        </Box>

        <Box mt={2}>
          <Typography variant="h6">3. Uso del Servicio</Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Utilizamos la integración con WhatsApp únicamente para:
          </Typography>
          <ul>
            <li>
              <Typography variant="body1">
                Enviar recordatorios y notificaciones automatizadas.
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                Proporcionar soporte al usuario.
              </Typography>
            </li>
          </ul>
        </Box>

        <Box mt={2}>
          <Typography variant="h6">4. Eliminación de Datos</Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Dado que no almacenamos información de los usuarios, no mantenemos
            registros que puedan ser eliminados directamente desde nuestro
            sistema. Sin embargo, si deseas gestionar la eliminación de tus
            datos en WhatsApp, puedes hacerlo a través de la configuración de
            privacidad de WhatsApp o contactando directamente con su soporte.
          </Typography>
          <Typography variant="body1">
            Para más información sobre la gestión de datos en WhatsApp, puedes
            visitar la{" "}
            <Link
              href="https://faq.whatsapp.com/"
              target="_blank"
              rel="noopener"
            >
              documentación oficial de WhatsApp
            </Link>
            .
          </Typography>
        </Box>

        <Box mt={2}>
          <Typography variant="h6">
            5. Modificaciones a los Términos y Condiciones
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Si realizamos cambios significativos, te notificaremos a
            través de nuestros canales oficiales.
          </Typography>
        </Box>

        <Box mt={2}>
          <Typography variant="h6">6. Contacto</Typography>
          <Typography variant="body1">
            Si tienes preguntas sobre nuestra política de privacidad o el manejo
            de tus datos, puedes contactarnos en{" "}
            <Link href="mailto:geraldvindasa@gmail.com">
              geraldvindasa@gmail.com
            </Link>
            .
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default PrivacyPolicy;
